/* eslint no-new: "off" */
import MotionWrapper from '../modules/MotionWrapper';

const processElementMotion = ({ selector, callback }) => {
	const elementList = document.querySelectorAll(selector);
	if (elementList.length > 0) {
		elementList.forEach((element) => {
			new MotionWrapper(
				element,
				0,
				callback ? () => callback(element) : null,
			);
		});
	}
};

export default processElementMotion;
